<app-page-header icon="group" title="Afiliados" subtitle="Listado de afiliados del sistema"></app-page-header>

<app-loading *ngIf="!flagLoaded" class="m-5"> </app-loading><br />

<div class="profile-area pb-70">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Afiliados</h3>
            <a routerLink="/afiliado-alta"
                ><i class="fas fa-plus"></i> Agregar Afiliado</a
            >
            <hr />

            <div class="search-container">
                <mat-form-field appearance="outline">
                    <mat-label>Buscar afiliado</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchTerm"
                        placeholder="Ingrese nombre, apellido o DNI"
                    />
                </mat-form-field>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="searchPersonas()"
                    [disabled]="!searchTerm"
                >
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>

            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <input
                    matInput
                    (keyup)="applyFilter($event)"
                    placeholder="Afiliado.."
                    autocomplete="off"
                />
            </mat-form-field>

            <div class="mat-elevation-z8" [hidden]="!(dataSource?.data?.length > 0)">
                <table mat-table [dataSource]="dataSource" matSort>

                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Nombre
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nombrePersona }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="apellido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Apellido
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.apellidoPersona }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nacionalidad">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Nacionalidad
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.paisNacimientoNombreEs }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="identificacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Identificación
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.identificacion }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaNacimiento">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Fecha nacimiento
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.birth | date: "dd-MM-yyyy" : "UTC" }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Email
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.email }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="telefono">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Teléfono
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.telefono }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Acciones
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="acciones-cell"
                        >
                            <button
                                style="margin-right: 5px"
                                (click)="
                                    element.signoSedes &&
                                        verDetalle(
                                            element.signoSedes[0],
                                            element._id
                                        )
                                "
                                [disabled]="!element.signoSedes"
                                type="button"
                                title="Ver sede asignada"
                                class="btn btn-primary"
                            >
                                <i class="fas fa-home"></i>
                            </button>

                            <button
                                style="margin-right: 5px"
                                (click)="verDetalleGecros(element)"
                                type="button"
                                title="Ver datos usuario"
                                class="btn btn-success"
                            >
                                <i class="fas fa-eye"></i>
                            </button>

                            <button
                                style="margin-right: 5px"
                                (click)="verPersona(element._id)"
                                type="button"
                                class="btn btn-warning"
                            >
                                <i class="fas fa-edit"></i>
                            </button>

                            <button
                                style="margin-right: 5px"
                                (click)="verUsuario(element._id)"
                                type="button"
                                title="Modificar datos usuario"
                                class="btn btn-warning"
                            >
                                <i class="fas fa-user"></i>
                            </button>

                            <button
                                type="button"
                                style="margin-right: 2%"
                                title="Modificar contraseña"
                                class="btn btn-danger"
                                (click)="openDialogModificarClave(element._id)"
                            >
                                <i class="fa fa-key" aria-hidden="true"></i>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                        class="example-element-row"
                    ></tr>
                </table>
            </div>

            <div class="no-results-container" *ngIf="dataSource && dataSource.data.length === 0 && flagLoaded">
                <div class="no-results-content">
                    <mat-icon class="no-results-icon">search_off</mat-icon>
                    <h4>No se encontraron afiliados</h4>
                    <p>No hay registros que coincidan con "{{ searchTerm }}"</p>
                    <button mat-button class="btn-clear-search" (click)="clearSearch()">
                        <mat-icon>refresh</mat-icon> Limpiar búsqueda
                    </button>
                </div>
            </div>
            <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 50, 100, 150, 200]"
                showFirstLastButtons
            ></mat-paginator>
        </div>
    </div>
</div>
